import React from 'react';
import { GlobalSegmentHandle } from '../../../context/types';
import { pbsSegmentationColors, segmentationMainColor } from '../../theme';
import { FilterSection } from '../filter/types';
import { FilterDrawer } from './FilterDrawer';
import { SegmentationState } from './types';

interface FilterDrawerProps {
  drawerState: SegmentationState;
  setDrawerState: (value: SegmentationState) => void;
  isFullScreen: boolean;
  segmentationHandle: GlobalSegmentHandle;
  filterSections: FilterSection[];
}

export const SegmentationFilterDrawer = (props: FilterDrawerProps) => {
  const {
    isFullScreen,
    drawerState,
    setDrawerState,
    segmentationHandle,
    filterSections,
  } = props;

  return (
    <FilterDrawer
      isFullScreen={isFullScreen}
      opened={drawerState}
      setClosed={() => setDrawerState('closed')}
      filterSections={filterSections}
      filterHandle={segmentationHandle}
      keyPrefix={'segmentation'}
      options={{
        mainBackgroundColor: segmentationMainColor,
        backgroundColors: pbsSegmentationColors,
        titleKey: 'common:segmentationTray.segmentationTray',
        myFilters: { enabled: false },
      }}
    />
  );
};
